import { Grid, SkeletonCard, SkeletonText, Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';

export const SecurityOverviewSkeleton = () => (
    <>
        <Stack spacing="100" itemAlignment="center" distribution="space-between">
            <Typography textStyle="titleMediumStrong" as="h1">
                {lt('SecurityOverviewTitle')}
            </Typography>
            <SkeletonText width="160px" />
        </Stack>

        <Grid templateColumns="1fr 1fr" gap="200">
            <SkeletonCard height="85px" />
            <SkeletonCard height="85px" />
            <SkeletonCard height="85px" />
            <SkeletonCard height="85px" />
        </Grid>
    </>
);
